import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import {
    IAuditChange,
    IAuditLog,
    IAuditLogDetail,
    ODataResponse,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import {
    excludeFor,
    extractChanges,
} from '@utils/audit.utils';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuditService extends ODataService<IAuditLog, number> {
    public reportsUrl: string;
    protected _endpoint: string;

    constructor(
        http: HttpClient,
        { authConfig }: AppStateFacade,
    ) {
        super(http, MapperService.auditMap);
        this._endpoint = `${authConfig.odataBaseUrl}/AuditLogs`;
        this.reportsUrl = `${this._endpoint}/UiPath.Server.Configuration.OData.Reports`;
    }

    public getLogDetails(log: IAuditLog): Observable<{ details: IAuditLogDetail[], changes: IAuditChange[] }> {
        const { id, component, action } = log;
        return this._http
            .get(`${this._endpoint}/UiPath.Server.Configuration.OData.GetAuditLogDetails(auditLogId=${id})`)
            .pipe(
                map((response) => {
                    const resultSet = this._mapData(response, MapperService.auditLogDetails) as ODataResponse<IAuditLogDetail>;
                    const details = resultSet.data;
                    details.forEach((_detail, index) => {
                        details[index] = excludeFor(component, 'All', details[index]);
                        details[index] = excludeFor(component, action, details[index]);
                    });
                    const changes = extractChanges(details, log);

                    return {
                        details,
                        changes,
                    };
                }),
            );
    }
}
